export const HAZARD_TYPES = [
  'MATERIAL_SUBSTANCE',
  'ENVIRONMENTAL',
  'THERMAL',
  'NOISE',
  'VIBRATION',
  'RADIATION',
  'ELECTRICAL',
  'MECHANICAL',
  'OTHER',
  'COMBINATION',
  'ERGONOMIC',
] as const

export const HAZARD_LIFECYCLES = [
  'CLEANING_MAINTENANCE',
  'SETTING_PROCESS_CHANGEOVER',
  'OPERATION',
  'ASSEMBLY_INSTALLATION_COMMISSIONING',
  'TRANSPORT',
  'TROUBLESHOOTING_FAULT_FINDING',
] as const
